import { useEffect, useState } from "react";
import {
  canChooseSpeaker,
  chooseDevice,
  chosenDevices,
  playOnSpeaker,
  type DeviceKind,
} from "./devices";
import { t } from "../i18n";

const pickers: [DeviceKind, MediaDeviceKind, string][] = [
  ["microphone", "audioinput", "الميكروفون"],
  ["camera", "videoinput", "الكاميرا"],
  ["speaker", "audiooutput", "مكبر الصوت"],
];

// Browsers name devices only once they may use them, so a picker appears after
// its permission and when there is more than one to choose from.
export function DevicePickers({
  testing,
  onMicrophone,
}: {
  testing: boolean;
  onMicrophone: () => void;
}) {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [choices, setChoices] = useState(chosenDevices);
  useEffect(() => {
    const read = () =>
      void navigator.mediaDevices
        ?.enumerateDevices()
        .then(setDevices)
        .catch(() => {});
    read();
    navigator.mediaDevices?.addEventListener("devicechange", read);
    return () =>
      navigator.mediaDevices?.removeEventListener("devicechange", read);
  }, [testing]);
  function choose(kind: DeviceKind, id: string) {
    chooseDevice(kind, id);
    setChoices(chosenDevices());
    if (kind === "microphone") onMicrophone();
    if (kind === "speaker") playOnSpeaker(id);
  }
  return (
    <div className="device-pickers">
      {pickers.map(([kind, deviceKind, label]) => {
        if (kind === "speaker" && !canChooseSpeaker()) return null;
        const options = devices.filter(
          ({ kind: found, label: name, deviceId }) =>
            found === deviceKind &&
            name &&
            !["default", "communications"].includes(deviceId),
        );
        if (options.length < 2) return null;
        return (
          <label key={kind}>
            {t(label)}
            <select
              value={choices[kind] ?? ""}
              onChange={(event) => choose(kind, event.target.value)}
            >
              <option value="">{t("الافتراضي في الجهاز")}</option>
              {options.map((device) => (
                <option key={device.deviceId} value={device.deviceId}>
                  {device.label}
                </option>
              ))}
            </select>
          </label>
        );
      })}
    </div>
  );
}
